var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:{br: _vm.indexHasBorderRight(_vm.index)}},[(_vm.value === null)?_c('span',[_vm._v(" - ")]):(_vm.value === 0)?_c('span',[_vm._v(" n.s. ")]):_c('span',[_vm._v(" "+_vm._s(_vm._f("formatPrice")(_vm.value))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }